// @need-translate

import {getEnv} from '../../../common/env/env';
import {twMerge} from '../../../common/twMerge';
import {
  LINK_ANDROID_STORE,
  LINK_IOS_STORE,
} from '../../../domain/bridge/applink/constant';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';

import {StaticImage} from '../../atoms/StaticImage/StaticImage';
import {StaticImageType} from '../../atoms/StaticImage/StaticImageType.enum';
import {Text} from '../../atoms/Text/Text';
import {ErrorAreaChildProps} from './ErrorAreaChildProps.interface';

export function ErrorAreaPcAppScheme({
  textClassName,
  className,
  ...props
}: {textClassName?: string} & ErrorAreaChildProps) {
  return (
    <div className={twMerge('flex space-x-40pxr', className)} {...props}>
      <div className="flex flex-col items-center space-y-12pxr">
        <Text
          className={twMerge('font-small2 text-theme-solid-100', textClassName)}
        >
          QR 코드 다운로드
        </Text>
        <div className="flex justify-center items-center border border-solid h-108pxr w-108pxr rounded-8pxr border-[rgb(var(--colors-static-mono-black)_/_70%)]">
          <StaticImage
            imageType={
              getEnv()?.appSchemeQrName || StaticImageType.AppSchemeQrReal
            }
          />
        </div>
      </div>
      <div className="flex flex-col items-center space-y-12pxr">
        <Text
          className={twMerge('font-small2 text-theme-solid-100', textClassName)}
        >
          앱스토어 다운로드
        </Text>
        <a
          href={LINK_ANDROID_STORE}
          target="_blank"
          rel="noopener noreferrer"
          onClick={e => LOG_CLICK_EVENT('플레이스토어_클릭', e)}
        >
          <StaticImage
            imageType={StaticImageType.AppSchemeGoogleplayPcStatic}
            className="cursor-pointer"
          />
        </a>
        <a
          href={LINK_IOS_STORE}
          target="_blank"
          rel="noopener noreferrer"
          onClick={e => LOG_CLICK_EVENT('앱스토어_클릭', e)}
        >
          <StaticImage
            imageType={StaticImageType.AppSchemeAppstorePcStatic}
            className="cursor-pointer"
          />
        </a>
      </div>
    </div>
  );
}

export const ErrorAreaPcAppSchemeType = (<ErrorAreaPcAppScheme />).type;
